import { Button } from "@/components/Product/ECommerce/components/orderButton/components/button";
import { StickyWrapper } from "@/components/Product/ECommerce/components/orderButton/components/stickyWrapper";
import { Base } from "@/components/Product/ECommerce/components/orderButton/orderButton.base";

export const OrderButton = Object.assign(Base, {
    Button: Button,
    StickyWrapper: StickyWrapper
});
